import React from "react";
import ReactDOM from "react-dom/client"; // Usar a nova API
import App from "./App";

// Criar a raiz usando a nova API do React 18
const root = ReactDOM.createRoot(document.getElementById("root"));

// Renderizar o componente App
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
